import React, { useState, useEffect } from "react";

import Header from "./Header";
import Footer from "./Footer";
const Layout = ({children}) =>{
    const isClientSide =  typeof window !== 'undefined';
    let initTheme =  isClientSide ? (localStorage.getItem("theme") || "light-theme") : "light-theme";

    const [theme, setTheme] = useState(initTheme);
    const changeTheme = (event) => {
        let newTheme = "light-theme";
        if(event.target.checked){
            newTheme = "dark-theme";
        }
        setTheme(newTheme);
    }

    useEffect(() => {
        if(isClientSide){
            localStorage.setItem("theme", theme);
        }
    }, [theme,isClientSide]);

    return (
        <div className={theme}>
            <Header theme={theme} changeTheme={changeTheme}/>
            <div>{children}</div>
            <Footer/>
        </div>
    )
}

export default Layout;